import { Currency } from '@godaddy/intl-formatter';
import { cookie } from '@ux/util';

export default (microunits) => {
  const market = cookie.get('market');
  const currency = cookie.get('currency');
  return new Currency().formatMicrounits(microunits, market, currency);
};
